import React, { useMemo } from 'react';
import { Filter, FilterFrame, FilterSelection } from '../Filters.style';
import { FilterOption } from '../../../types';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import FilterExposedHeader from '../FilterExposedHeader';
import { ModelYearListWrapper } from './ModelYearSelector.style';
import CheckboxSelector from '../../CheckboxComponent';
import useAnimations from '../../../hooks/Animations/useAnimations';

interface ModelYearSelectorTypes {
  filterType: string;
  modelYearOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;
  availableFilters: Record<string, number>;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string, isChecked: boolean) => void;
  handleExposeFilter: (arg: string) => void;
}

const ModelYearSelector: React.FC<ModelYearSelectorTypes> = ({
  filterType,
  modelYearOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
  availableFilters,
}) => {
  const selectedModelYearsList = useMemo(() => {
    const seletedModelYearOptions = confirmedFilters.modelYear;
    return seletedModelYearOptions.map((year) => modelYearOptions[year].label).join(', ');
  }, [confirmedFilters.modelYear, modelYearOptions]);

  const selectedModelYears = useMemo(() => {
    return confirmedFilters.modelYear;
  }, [confirmedFilters.modelYear]);

  const handleAddModelYearFilter = (newYear: string, isChecked: boolean) => {
    handleAddFilter('modelYear', newYear, isChecked);
  };

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  // Sorting year by DESC
  const modelYearsList = Object.keys(modelYearOptions).sort((a, b) => Number(b) - Number(a));

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedModelYearsList}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props}>
              <FilterFrame style={filtersAccordianAnimation}>
                <ModelYearListWrapper data-testid="modelYear-list">
                  {modelYearsList.map((filterOption) => {
                    const option = modelYearOptions[filterOption];
                    // is disabled when there is no offer for that model Year
                    const isDisabled =
                      !Object.keys(availableFilters).includes(option.value.toString()) ||
                      !availableFilters[option.value];
                    return (
                      <CheckboxSelector
                        inputName={`${filterType}-${option.value}`}
                        key={option.value}
                        onChange={() =>
                          handleAddModelYearFilter(
                            option.value,
                            selectedModelYears.includes(option.value),
                          )
                        }
                        value={option.value}
                        label={option.label}
                        ariaLabel={option.ariaLabel}
                        checked={selectedModelYears.includes(option.value)}
                        disabled={isDisabled}
                        hint={isDisabled ? '0' : availableFilters[option.value]?.toString()}
                      />
                    );
                  })}
                </ModelYearListWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default ModelYearSelector;
